export const initialise = () => {
    siteSwitcher();
};

const siteSwitcher = () => {
    const container = document.querySelector<HTMLDivElement>('.main-site-header__site-switcher');
    const button = document.querySelector<HTMLButtonElement>('.main-site-header__site-switcher-button');
    const dropdown = document.querySelector<HTMLDivElement>('.main-site-header__site-switcher-dropdown');

    if (!container || !button || !dropdown) return;

    const toggleMenu = (open: boolean) => {
        button.setAttribute('aria-expanded', open.toString());
        dropdown.setAttribute('aria-hidden', (!open).toString());

        if (open) {
            document.addEventListener('click', handleOutsideInteraction);
            document.addEventListener('keyup', handleOutsideInteraction);
            
            const firstLink = dropdown.querySelector<HTMLAnchorElement>('a');
            firstLink?.focus(); 
        } else {
            document.removeEventListener('click', handleOutsideInteraction);
            document.removeEventListener('keyup', handleOutsideInteraction);
        }
    };

    const handleOutsideInteraction = (event: Event) => {
        if (event instanceof KeyboardEvent && event.key !== 'Tab') return;

        const target = event.target as HTMLElement;
        if (!container.contains(target)) {
            toggleMenu(false);
        }
    };

    button.addEventListener('click', (e) => {
        e.stopPropagation();
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        toggleMenu(!isExpanded);
    });
};
